export default "__VITE_ASSET__7ed89b5e__"